module.exports = __webpack_public_path__ + "img/image_present.f077ec44.png";